export enum AssignmentParticipantSkillStateEnum {
    Lacking = 1,
    InPossession = 2,
    Extending = 3,
}